var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"rocket-effect-container",class:_vm.getPageClasses()},[_c(_vm.componentName,_vm._b({ref:"",tag:"component"},'component',_vm.mergedAttr,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }